<!-- SessionListComponent — Lista de sesiones de conversación anteriores -->
<!-- Req 4.2, 4.3, 5.3, 5.7, 5.8 -->

<div class="session-list">

  <!-- =========================================================
       Botón "Nueva conversación"
       ========================================================= -->
  <button
    class="btn btn-sm w-100 mb-2 session-list__new-btn"
    (click)="createNewSession()"
    title="Iniciar una nueva conversación"
    aria-label="Nueva conversación"
    type="button"
  >
    <i class="bi bi-plus-lg me-1" aria-hidden="true"></i>
    Nueva conversación
  </button>

  <!-- =========================================================
       Lista de sesiones
       ========================================================= -->
  <div
    class="session-list__items"
    role="list"
    aria-label="Conversaciones anteriores"
  >

    <!-- Estado vacío: sin sesiones -->
    <div
      *ngIf="sessions.length === 0"
      class="session-list__empty"
      aria-live="polite"
    >
      <i class="bi bi-chat-square-text session-list__empty-icon" aria-hidden="true"></i>
      <span class="session-list__empty-text">Sin conversaciones anteriores</span>
    </div>

    <!-- Ítem de sesión -->
    <button
      *ngFor="let session of sessions; trackBy: trackBySessionId"
      class="session-list__item"
      [class.session-list__item--active]="activeSession?.session_id === session.session_id"
      (click)="selectSession(session)"
      [attr.title]="getSessionTitle(session)"
      [attr.aria-pressed]="activeSession?.session_id === session.session_id"
      [attr.aria-label]="'Seleccionar conversación: ' + getSessionTitle(session)"
      role="listitem"
      type="button"
    >
      <!-- Icono de conversación -->
      <span class="session-list__item-icon" aria-hidden="true">
        <i class="bi bi-chat-text"></i>
      </span>

      <!-- Contenido: título + fecha -->
      <span class="session-list__item-content">
        <span class="session-list__item-title">{{ getSessionTitle(session) }}</span>
        <span class="session-list__item-date">{{ formatSessionDate(session.updated_at) }}</span>
      </span>
    </button>

  </div>

</div>
